/* global axios */
import ApiClient from '../ApiClient';

class EvolutionChannel extends ApiClient {
  constructor() {
    super('channels/evolution_channel', { accountScoped: true });
  }

  createInstance(data) {
    return axios.post(`${this.url}/create_instance`, data);
  }

  checkStatus(instanceName) {
    return axios.get(`${this.url}/status?instance_name=${instanceName}`);
  }

  createInbox(data) {
    return axios.post(`${this.url}`, data);
  }
}

export default new EvolutionChannel();
